import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchProjectsData } from '../utils/googleSheets';

const ProjectsContext = createContext();

export const useProjects = () => {
  const context = useContext(ProjectsContext);
  if (!context) {
    throw new Error('useProjects must be used within a ProjectsProvider');
  }
  return context;
};

export const ProjectsProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadProjects = async () => {
      try {
        setLoading(true);
        const data = await fetchProjectsData();
        
        // Filter out projects without Project Image 1
        const validProjects = data.filter(project => project['Project Image 1']);
        
        setProjects(validProjects);
        setError(null);
      } catch (err) {
        console.error('Failed to load projects:', err);
        setError('Failed to load projects');
        setProjects([]);
      } finally {
        setLoading(false);
      }
    };

    loadProjects();
  }, []);

  const getProjectById = (id) => {
    return projects.find(project => project.id === parseInt(id));
  };

  const getFeaturedProjects = () => {
    // Show all 8 projects on the home page as requested
    return projects.slice(0, 8);
  };

  const value = {
    projects,
    loading,
    error,
    getProjectById,
    getFeaturedProjects
  };

  return (
    <ProjectsContext.Provider value={value}>
      {children}
    </ProjectsContext.Provider>
  );
};